import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["placeholder"]

import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBarTag',
  props: {
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Rechercher...' },
  icon: { type: String, default: '/media/icons/search-icon.svg' },
  css: { type: String, default: '' },
},
  emits: ['update:modelValue', 'search', 'enter'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const searchInput = ref<HTMLInputElement | null>(null);
const searchTerm = ref(props.modelValue);

// Keep the local value in sync with a controlled modelValue (no search fired)
watch(() => props.modelValue, (val) => {
  if (val !== searchTerm.value) searchTerm.value = val;
});

// Emit update:modelValue on every keystroke so v-model stays reactive,
// but DO NOT fire the 'search' event here — search only runs on explicit submit.
watch(searchTerm, (val) => {
  emit('update:modelValue', val);
});

const submitSearch = () => {
  emit('search', searchTerm.value);
};

const clearSearch = () => {
  searchTerm.value = '';
  emit('search', '');
};

const handleKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    emit('enter', searchTerm.value);
    submitSearch();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.css, 'relative flex items-center px-4 py-2 my-2 space-x-4 bg-transparent border rounded-lg border-secondary focus-within:ring-2 focus-within:ring-secondary-700 focus-within:ring-inset'])
  }, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "searchInput",
      ref: searchInput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      type: "text",
      onKeydown: handleKeydown,
      class: "w-full text-white placeholder-gray-500 bg-transparent outline-none focus:outline-none",
      placeholder: __props.placeholder
    }, null, 40, _hoisted_1), [
      [_vModelText, searchTerm.value]
    ]),
    (searchTerm.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: clearSearch,
          class: "text-white hover:text-red-400 focus:outline-none",
          title: "Effacer"
        }, " ✕ "))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      onClick: submitSearch,
      class: "focus:outline-none cursor-pointer hover:opacity-80 transition-opacity",
      title: "Rechercher"
    }, [
      _createVNode(_component_Icon, {
        src: __props.icon,
        class: "w-5 h-5 text-white"
      }, null, 8, ["src"])
    ])
  ], 2))
}
}

})